eyebrow: "What We Do"
headline: "An agency built around<br/><em>your operational reality.</em>"
lead: "We don't sell software licenses or retainer hours. We partner with you to understand the exact workflows costing your team time — then design, build, and embed the AI layer that eliminates them."

cards:
  - num: "01"
    icon: "🔍"
    title: "AI Workflow Audits"
    body: "A structured deep-dive into your current operations. We map every manual touchpoint, quantify the time cost, and deliver a prioritised automation roadmap — before you spend a penny on build."
  - num: "02"
    icon: "🛠️"
    title: "Custom AI System Design"
    body: "Architecture that fits your compliance requirements, data sensitivity, and existing stack. Not a template. Not a wrapper. A purpose-built system designed to slot into how your team actually works."
  - num: "03"
    icon: "⚡"
    title: "Precision Engineering"
    body: "High-accuracy NLP, OCR, and AI reasoning — built and tested against your real documents and real edge cases. We ship systems that perform in production, not just in demos."
  - num: "04"
    icon: "🔗"
    title: "Workflow Orchestration"
    body: "N8N, Composio, and custom pipeline integrations that connect your tools, automate handoffs, and eliminate the manual glue holding your stack together. We build the flows that run while you sleep."
  - num: "05"
    icon: "📊"
    title: "Continuous Enablement"
    body: "Autonomy isn't a one-time setup. We monitor performance, refine accuracy, and evolve the system as your operational needs and AI capabilities grow — on an ongoing basis."
  - num: "06"
    icon: "🎯"
    title: "Strategic AI Consultancy"
    body: "Not ready to build yet? We offer standalone strategy sessions — helping leadership teams understand where AI creates real leverage versus where it's noise, and what a realistic roadmap looks like."
